import { useMutation } from '@tanstack/react-query';

export interface UseDownloadQrBatch {
  download: (id: string) => void;
  // The batch whose file is on its way, so only its button shows it.
  downloadingId: string | null;
  // The batch whose last download failed; cleared by the next attempt.
  failedId: string | null;
}

// A read with a side effect (the browser saves a file), so a mutation rather than a query: nothing
// is cached, and nothing is retried behind the person's back.
export function useDownloadQrBatch(downloadQrBatch: (id: string) => Promise<void>): UseDownloadQrBatch {
  const mutation = useMutation({ retry: false, mutationFn: downloadQrBatch });

  return {
    download: (id) => {
      mutation.mutate(id);
    },
    downloadingId: mutation.isPending ? mutation.variables : null,
    failedId: mutation.isError ? mutation.variables : null,
  };
}
